import { render, staticRenderFns } from "./DocumentGroupDash.vue?vue&type=template&id=75a4c7ce&scoped=true&"
import script from "./DocumentGroupDash.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a4c7ce",
  null
  
)

export default component.exports